export { default } from './svg/add.svg';
